























































































































































import { Component, Vue } from "vue-property-decorator";
import Api from "@/api";
import Table from "@/components/Common/Table.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";

import swal from "sweetalert";
import { IInventoryProduct, IPagination, ITableParams } from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    Table,
    AlertBox
  }
})
export default class InventoryProducts extends Vue {
  public loading = false;
  public updating = false;
  private componentKey = 0;
  private inventoryProducts: Array<IInventoryProduct> = [];
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    search: ""
  };

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      if (vm.$route.query.inventory_product_deleted === "true") {
        swal("Success!", "The inventory product was deleted.", "success").then(
          () => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          }
        );
      }
      vm.getInventoryProducts(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.inventory_product_deleted === "true") {
      swal("Success!", "The inventory product was deleted.", "success").then(
        () => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        }
      );
    }
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getInventoryProducts(() => {
      //
    });
    next();
  }

  private getInventoryProducts(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.inventoryProducts = [];
    const endpoint: string = this.$partnerEndpoint("inventory-products");

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          perPage: this.fetchParams.per_page,
          search: this.fetchParams.search
        }
      })
      .then((response: AxiosResponse) => {
        this.inventoryProducts = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteInventoryProduct(inventoryProductId: number): void {
    if (this.loading || this.updating || inventoryProductId == null) {
      return;
    }

    swal({
      title: "Are you sure?",
      text:
        "The inventory product will be deleted and will not be able to use it",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "inventory-products/" + inventoryProductId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "InventoryProducts",
                query: { inventory_product_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal(
                    "Success!",
                    "The inventory product was deleted.",
                    "success"
                  );
                  this.getInventoryProducts(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete inventory product.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }
}
